import React from 'react';
import { Box, Grid } from '@mui/material';
import Header from '../../mainpagecomponents/Header';
import BlogSubmit from './BlogSubmit';
import PrivateBlogManager from './PrivateBlogManager';
import usePrivateBlogs from './blog_hooks/usePrivateBlogs';

const BlogEditor = () => {
    const [blogs, refreshBlogs] = usePrivateBlogs(true);
    //Added
    return (
        <>
            <Header />

            {/* Green Gradient Spacer below header */}
            <Box
                sx={{
                    width: '100%',
                    height: 80,
                    background: 'linear-gradient(to right, #6E8B3D, #A7BF5C)',
                }}
            />

            {/* Full-Width Grid Container */}
            <Grid
                container
                spacing={0}
                sx={{
                    height: '100%',
                    minHeight: 'calc(100vh - 80px)',
                    backgroundColor: '#FAFAF5',
                }}
            >
                {/* LEFT: Blog List */}
                <Grid item xs={12} md={4} sx={{ p: 4 }}>
                    <Box
                        sx={{
                            height: '100%',
                            borderRadius: 3,
                            backgroundColor: 'white',
                            boxShadow: 3,
                            p: 3,
                        }}
                    >
                        <PrivateBlogManager blogs={blogs} refreshBlogs={refreshBlogs} />
                    </Box>
                </Grid>

                {/* RIGHT: Blog Submit */}
                <Grid item xs={12} md={6} sx={{ p: 4 }}>
                    <Box
                        sx={{
                            height: '100%',
                            borderRadius: 3,
                            backgroundColor: 'white',
                            boxShadow: 3,
                            p: 3,
                        }}
                    >
                        <BlogSubmit blogs={blogs} refreshBlogs={refreshBlogs} />
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

export default BlogEditor;
